export default __webpack_public_path__ + "static/media/vaadin.de2b2e0c.svg";